var modules_3999ddfa = {"iframe":"_h4l6og"};
import "../../../../../assets/BY9MQcY9.css";

export { modules_3999ddfa as default };
//# sourceMappingURL=Iframe.module.scss.js.map
